import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';

function Group({ group, items }) {
  return (
    <li>
      {group && (
        <Stack direction="row" spacing={1} sx={{ px: 2, py: 1 }}>
          <Box sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
            {group}
          </Box>
        </Stack>
      )}
      <Box>{items}</Box>
    </li>
  );
}

Group.propTypes = {
  group: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default Group;
